import { Tuss } from '../types';

export const defaultTuss: Tuss = { id: null, name: '' };
